var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@robinpowered/ui-kit';
import { useWatch } from 'react-hook-form';
import { useCallback } from 'react';
import { SpaceComponent } from './SpaceComponent';
import { SpaceDetailsProvider } from './SpaceDetailsContext';
import { AddSectionButton } from '../common/AddSectionButton';
import { useEventComposerGlobalContext } from '../../composers/EventComposerGlobalContext';
/* @TODO[Spaces] this is getting large clean it up */
export var EventSpaceWrapper = function (_a) {
    var isLoadingEvent = _a.isLoadingEvent, fetchingSpace = _a.fetchingSpace, eventPermissions = _a.eventPermissions, initialEvent = _a.initialEvent, checkSpaceDeletionPermission = _a.checkSpaceDeletionPermission;
    var t = useTranslation('meetingRooms').t;
    var _b = useEventComposerGlobalContext(), setSpaceBookingOpen = _b.setSpaceBookingOpen, requestOnlySpace = _b.requestOnlySpace, setPendingSpaceSwap = _b.setPendingSpaceSwap;
    var isSpaceRequestOnlyEvent = !!requestOnlySpace;
    var _c = __read(useWatch({
        name: ['spaces'],
    }), 1), spaces = _c[0];
    var onChangeSpace = useCallback(function (spaceId) {
        setPendingSpaceSwap({ spaceId: spaceId });
        setSpaceBookingOpen(true);
    }, [setPendingSpaceSwap, setSpaceBookingOpen]);
    if (isLoadingEvent) {
        return null;
    }
    if (fetchingSpace) {
        return _jsx(Skeleton, {});
    }
    // The "Space" label, count and collapsed summary are owned by the wrapping
    // ComposerSection; this renders just the section's inner content (space
    // cards + the dashed "add another space" button).
    return (_jsxs(SpaceItemWrapper, { children: [spaces === null || spaces === void 0 ? void 0 : spaces.map(function (space) {
                return (_jsx(SpaceDetailsProvider, { eventPermissions: eventPermissions, initialEvent: initialEvent, spaceId: space.id, children: _jsx(SpaceComponent, { spaceId: space.id, spaceInviteeId: space === null || space === void 0 ? void 0 : space.inviteeId, 
                        // The organizer space IS the event's calendar identity —
                        // removing or swapping it would orphan the event, so its
                        // card offers no actions regardless of user permissions.
                        userCanRemoveSpace: !!(checkSpaceDeletionPermission === null || checkSpaceDeletionPermission === void 0 ? void 0 : checkSpaceDeletionPermission()) && !space.isOrganizer, onChangeSpace: onChangeSpace }) }, space.id));
            }), !isSpaceRequestOnlyEvent && (spaces === null || spaces === void 0 ? void 0 : spaces.length) && (_jsx(AddSectionButton, { onClick: function () { return setSpaceBookingOpen(true); }, label: t("spaces.add_another_space") }))] }));
};
var SpaceItemWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"])));
export var SpaceInfoWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 12px;\n  border-top: ", ";\n"], ["\n  padding: 12px;\n  border-top: ", ";\n"])), function (_a) {
    var showBorder = _a.showBorder;
    return showBorder
        ? "1px solid var(--ant-color-border-secondary, rgba(0, 0, 0, 0.06))"
        : 'none';
});
var templateObject_1, templateObject_2;
